import { jwtDecode } from 'jwt-decode'
import { z } from 'zod'

const PtvSessionSchema = z
  .object({
    user_id: z.number(),
    active: z.boolean(),
    authenticated: z.boolean(),
    email_addr: z.string(),
    first_name: z.string(),
    last_name: z.string(),
    admin: z.boolean(),
    demo: z.boolean().optional(),
    role_scope: z.union([z.literal('customer'), z.string()]),
    user_role_id: z.number().nullable(),
    role_name: z.string().optional(),
    current_advertiser: z.object({
      email: z.string().optional(),
      advertiser_id: z.number().optional(),
      company_name: z.string().optional(),
      company_url: z.string().optional(),
      time_zone: z.string().optional(),
      product_version_id: z.number().optional(),
    }),
    iat: z.number(),
    exp: z.number(),
  })
  .transform(v => ({
    userId: v.user_id,
    active: v.active,
    authenticated: v.authenticated,
    emailAddr: v.email_addr,
    firstName: v.first_name,
    lastName: v.last_name,
    admin: v.admin,
    roleScope: v.role_scope,
    roleName: v.role_name,
    userRoleId: v.user_role_id,
    demo: v.demo,
    currentAdvertiser: {
      email: v.current_advertiser.email,
      advertiserId: v.current_advertiser.advertiser_id,
      companyName: v.current_advertiser.company_name,
      companyUrl: v.current_advertiser.company_url,
      timeZone: v.current_advertiser.time_zone,
      productVersionId: v.current_advertiser.product_version_id,
    },
    iat: v.iat,
    exp: v.exp,
  }))

const PtvSessionTokenSchema = z.string().transform((token, ctx) => {
  try {
    return jwtDecode(token)
  } catch {
    ctx.addIssue({
      code: 'custom',
      message: 'Invalid JWT token',
    })
  }
})

export const PtvSessionFromTokenSchema = PtvSessionTokenSchema.pipe(PtvSessionSchema)

export type PtvSession = {
  userId: number
  active: boolean
  authenticated: boolean
  emailAddr: string
  firstName: string
  lastName: string
  admin: boolean
  roleScope: 'customer' | string
  roleName?: string
  userRoleId: number | null
  currentAdvertiser: {
    email?: string
    advertiserId?: number
    companyName?: string
    companyUrl?: string
    timeZone?: string
    productVersionId?: number
  }
  demo: boolean | undefined
  iat: number
  exp: number
}
